/**
 * Date-extensions locale Slovenian [sl]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('sl', {
    monthNames: ['Januar','Februar','Marec','April','Maj','Junij','Julij','Avgust','September','Oktober','November','December'],
    monthShortNames: ['Jan.','Feb.','Mar.','Apr.','Maj.','Jun.','Jul.','Avg.','Sep.','Okt.','Nov.','Dec.'],
    dayNames: ['Nedelja','Ponedeljek','Torek','Sreda','četrtek','Petek','Sobota'],
    dayShortNames: ['Ned.','Pon.','Tor.','Sre.','čet.','Pet.','Sob.']
});
